// Generated by scripts/generateIconNames.mjs. Do not edit by hand.

export const birkenIcons = [
	"Avfall_mat",
	"Avfall_pant",
	"Avfall_restavfall",
	"Bagasje",
	"Bagasjetransport",
	"Birken",
	"BirkenInfo",
	"Drikkestasjon",
	"DropOff",
	"Dusj",
	"Finish",
	"Fluortest",
	"FriskisSvettis",
	"FunkBule",
	"Grill",
	"Helikopterlanding",
	"Innkjøring_forbudt",
	"Kiosk",
	"Luft",
	"Matstasjon",
	"Merketidtavle",
	"Miljøtorg",
	"Parkering",
	"Parkering_Funk",
	"Parkering_HC",
	"Parkering_teambusser",
	"Parkering_VIP",
	"Parkering_Vogntog",
	"Port",
	"Presse",
	"Redbull_sprint",
	"Rosinbakkene",
	"Sanitet",
	"Sermoni",
	"Ski_oppvarmingsløyper",
	"Ski_oppvarmingsløyper_v2",
	"Ski_staver_innlevering",
	"SkiClassic",
	"Skiservice",
	"Skistall",
	"Skyttelbuss",
	"Skyttelbuss_Bilett",
	"Speaker",
	"Sport1_Marked",
	"Sport1_Messe",
	"Sprint",
	"Start",
	"Startnummerutdeling",
	"Startsluse",
	"Sykeltransport",
	"Sykkelparkering",
	"Sykkelservice",
	"Sykkelvask",
	"Tidtaking",
	"Veksling",
	"Vektkontroll",
	"Vertshus",
	"Vertshus_VIP",
	"VIP_mat",
	"WC"
] as const;

export const goteborgsvarvetIcons = [
	"Atervinning",
	"Banan",
	"Barnaktiviteter",
	"Dusch",
	"Dusch_dam",
	"Dusch_herr",
	"Dusch_ickebinar",
	"Hallplats",
	"Hjartstartare",
	"Info",
	"Kran",
	"Massage",
	"Mat",
	"Musik",
	"Parkering",
	"Repet",
	"Skrapzon",
	"Talt",
	"Tillganglighet",
	"Tillganglighet_exit",
	"Tillganglighet_wc",
	"Toalett",
	"Trafik_forbjuden",
	"Transport_till_mal",
	"Uppvarmning",
	"Vaskinlamning",
	"Vatska"
] as const;

export const vasaloppetIcons = [
	"artboard-3",
	"bagage",
	"bil",
	"buss",
	"cykel",
	"dam",
	"diplom",
	"dusch",
	"gaende-man",
	"handikapp",
	"herr",
	"herr-o-dam",
	"info",
	"man-leder-cykel",
	"man-pa-cykel",
	"medalj",
	"nummerlapp",
	"papperskorg",
	"parkering",
	"polis",
	"restaurang",
	"sang",
	"service",
	"sjukvard",
	"skidor",
	"skidor-stavar",
	"sok",
	"valla",
	"varm-balja",
	"varm-dryck",
	"varm-hand"
] as const;

export const vatternrundanIcons = [
	"bicycle-parking",
	"bicyle-pump",
	"bike-rental",
	"change-start",
	"massage",
	"number-bibs",
	"wash-bike"
] as const;
